import React from 'react'
import { Tooltip, Typography } from '@material-ui/core'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import clsx from 'clsx'

export const TruncatedTextWithTooltip = ({
  text,
  limitSize = 20,
  typographyProps,
}) => {
  const getTruncatedText = R.when(
    R.o(R.gt(R.__, limitSize), R.length),
    R.pipe(R.take(limitSize), R.append('…'), R.join('')),
  )

  return (
    <Tooltip title={text}>
      <Typography
        {...typographyProps}
        className={clsx(R.prop('className', typographyProps), 'truncate')}
      >
        {getTruncatedText(text)}
      </Typography>
    </Tooltip>
  )
}

TruncatedTextWithTooltip.propTypes = {
  text: PropTypes.string.isRequired,
  limitSize: PropTypes.number,
  typographyProps: PropTypes.object,
}
